export default __webpack_public_path__ + "static/media/together_key_icon.27655832.svg";